export default __webpack_public_path__ + "static/media/best_grey.21a6ac37.png";